<template>
  <v-app app>
    <pulse-spinner class="pulse-position" :loading="loading"></pulse-spinner>
    <notifications group="login" position="bottom left" />
    <notifications position="bottom left" />
    <v-app-bar
      flat
      app
      :color="constants.toolbarColors"
      dark
      fixed
      :src="images.bgTruck"
      fade-img-on-scroll
      scroll-threshold="500"
      class="overflow-hidden text-center"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(80, 0, 0.85), rgba(80, 0, 0,.85)"
        ></v-img>
      </template>

      <v-app-bar-nav-icon
        v-if="!appBarTitle && isLogged"
        @click="onClickHamburguerButton()"
      ></v-app-bar-nav-icon>

      <v-app-bar-nav-icon v-if="appBarTitle" @click="onClickBackButton()">
        <v-btn icon>
          <v-icon>
            fas fa-long-arrow-alt-left
          </v-icon>
        </v-btn>
      </v-app-bar-nav-icon>

      <div class="d-flex align-center">
        <v-img
          v-if="!appBarTitle"
          alt="Zaro logo"
          class="shrink"
          contain
          :src="images.zaroLogoWhite"
          transition="fade-transition"
          width="100"
          height="50"
        />
        <h3
          v-if="appBarTitle"
          class="ml-2 fill-height text-center title font-weight-regular"
        >
          {{ appBarTitle ? appBarTitle : "" }}
        </h3>
      </div>

      <v-spacer></v-spacer>

      <v-row justify="space-around">
        <v-spacer></v-spacer>
        <v-badge
          v-if="isLogged"
          class="mr-4 mt-4"
          content="0"
          value="6"
          color="green"
          overlap
        >
          <v-icon>mdi-email</v-icon>
        </v-badge>
        <v-col
          class="no-padding mr-1"
          xs="3"
          sm="3"
          md="3"
          lg="2"
          xl="2"
          cols="7"
        >
          <v-select
            hide-details
            :items="languageList"
            item-text="name"
            v-model="langSelect"
            solo
            flat
            :background-color="constants.accentColor"
            @change="setLang($event)"
          >
            <template v-slot:selection="{ item }">
              <v-img
                class="mobile-lang-img"
                :src="item.icon"
                aspect-ratio="1"
                size="17px"
                :height="constants.langSelectIconH"
                :width="constants.langSelectIconW"
                :max-width="constants.langSelectIconMW"
                :max-height="constants.langSelectIconMH"
              ></v-img>
              <p class="ma-0 text-center pl-4">{{ item.name }}</p>
            </template>
            <template v-slot:item="{ item }">
              <v-img
                class="ml-4"
                :src="item.icon"
                aspect-ratio="1"
                size="17px"
                :height="constants.langSelectIconH"
                :width="constants.langSelectIconW"
                :max-width="constants.langSelectIconMW"
                :max-height="constants.langSelectIconMH"
              ></v-img>
              <p class="ma-0 pa-0 pl-2">{{ item.name }}</p>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-app-bar>

    <!-- Main Content -->
    <v-content>
      <transition name="fade">
        <router-view v-on:setLogin="setLogin($event)"></router-view>
      </transition>
    </v-content>

    <!-- Navigation Sidebar -->
    <sidebar-component />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    images: {},
    icons: {},
    langSelect: 0,
    items: [],
    colors: ["primary", "blue", "success", "red", "teal"],
  }),
  created() {
    this.images = {
      zaroLogo: require("@/" + this.constants.urlImg + "logoOnly.png"),
      zaroLogoWeb: require("@/" + this.constants.urlImg + "ram_logo.png"),
      zaroLogoWhite: require("@/" +
        this.constants.urlImg +
        "zaroLogoWhite.png"),
      bgTruck: require("@/" + this.constants.urlImg + "bg-videos.webp"),
    };
    this.langSelect = this.$store.state.langs.short;
    this.$store.dispatch("userModule/verifyLoginState");
  },
  computed: {
    loading() {
      return this.$store.state.UI.loaders.loading;
    },
    constants() {
      return this.$store.state.constantsModule;
    },
    languageList() {
      return this.$store.state.langs.langNames;
    },
    selectedLanguage() {
      return this.$store.state.langs.language;
    },
    drawer() {
      return this.$store.state.UI.sidebar.drawer;
    },
    appBarTitle() {
      return this.$store.state.UI.appBar.title;
    },
    isLogged() {
      return this.$store.state.userModule.isLogged;
    },
  },
  methods: {
    setLang(lang) {
      this.$store.dispatch("langs/languageSet", lang);
    },
    onClickHamburguerButton() {
      this.$store.dispatch("UI/sidebar/changeDrawerState", !this.drawer);
    },
    onClickBackButton() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style>
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #b30000;
  border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
